// extracted by mini-css-extract-plugin
module.exports = {"default":"_2v7GEEZ8ip8fwHh7ik1vLF"};